import { createStore, type Store } from 'react-sweet-state';

import { type AgentModalStoreActions } from './AgentModalStoreActions';

export type AgentModalStoreState = {
	isOpen: boolean;
};

export const store: Store<AgentModalStoreState, AgentModalStoreActions> = createStore<
	AgentModalStoreState,
	AgentModalStoreActions
>({
	initialState: {
		isOpen: false,
	},
	name: 'AgentModalStore',
	actions: {
		openAgentModal:
			() =>
			({ setState }) => {
				setState({
					isOpen: true,
				});
			},
		closeAgentModal:
			() =>
			({ setState }) => {
				setState({
					isOpen: false,
				});
			},
	},
});
